import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {recieveMsg} from "../redux/actions/Socket.Action";

function useWebSocket() {
  const [socket, setSocket] = useState(null);
  const [message, setMessage] = useState(null);
  const [connected, SetConnected] = useState(true);
  const user = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const url = `wss://${process.env.REACT_APP_API_URL}/ws`;
  useEffect(() => {
    const ws = new WebSocket(url);

    ws.onopen = () => {
      setSocket(ws);
      sendMessage("ping");
    };

    ws.onmessage = (event) => {
      setMessage(event.data);
      const payload = JSON.parse(event.data);
      if (payload.type) {
        dispatch(recieveMsg(payload));
      }
    };
    ws.onclose = () => {
      SetConnected(false);
    };
    ws.onerror = () => {
      SetConnected(false);
    };
    return () => {
      ws.close();
    };
  }, [connected]);

  const sendMessage = (type = false, action = false, message = false) => {
    const data = {
      Authorization: process.env.REACT_APP_API_KEY,
      Token: user.Token,
      UserID: user.userData.user_id,
      type: type,
      action: action,
      data: message,
    };
    if (socket) {
      socket.send(JSON.stringify(data));
    }
  };

  return [sendMessage];
}

export default useWebSocket;
